import { themeAtom } from "../../shared/atoms";
import { BlurredAlertProps } from "../models/WarningMessage.model";
import { useAtomValue } from "jotai";
import React from "react";
import ReactDOM from "react-dom";
import { twMerge } from "tailwind-merge";

const BlurredAlert: React.FC<BlurredAlertProps> = ({ message, onClose }) => {
  const theme = useAtomValue(themeAtom);

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/5 backdrop-blur-sm" onClick={onClose}>
      <div
        id="alert-box"
        className={twMerge(
          "z-50 flex h-[140px] w-[280px] flex-col justify-between rounded-xl border px-4 py-3 shadow-xl",
          theme.home.tailwind.backgound,
          theme.uwhcAssistant.border,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={twMerge("ml-4 mt-4 text-left text-[14px]", theme.uwhcAssistant.text)}>{message}</div>

        <div className="flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className={twMerge(
              "focus:ring-green-200 mb-3 mr-3 h-[36px] w-[60px] flex-shrink-0 rounded border border-green text-[14px] text-green hover:bg-green focus:outline-none",
              theme.headerComponent.notifications.itemBackground,
              theme.headerComponent.tailwind.buttonHoverText,
            )}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default BlurredAlert;
